var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 6C21.0001 5.20435 20.684 4.44129 20.1214 3.87868C19.5588 3.31607 18.7957 3 18.0001 3H6.00006C5.39605 3.00358 4.80718 3.1894 4.31052 3.53315C3.81385 3.8769 3.43251 4.36257 3.21641 4.92661C3.0003 5.49065 2.95949 6.10679 3.09931 6.6944C3.23913 7.28202 3.55307 7.81374 4.00006 8.22V18C4.00006 18.7956 4.31613 19.5587 4.87874 20.1213C5.44135 20.6839 6.20441 21 7.00006 21H17.0001C17.7957 21 18.5588 20.6839 19.1214 20.1213C19.684 19.5587 20.0001 18.7956 20.0001 18V8.22C20.3127 7.94042 20.5632 7.59839 20.7354 7.21601C20.9077 6.83363 20.9978 6.41938 21.0001 6ZM6.00006 5H18.0001C18.2653 5 18.5196 5.10536 18.7072 5.29289C18.8947 5.48043 19.0001 5.73478 19.0001 6C19.0001 6.26522 18.8947 6.51957 18.7072 6.70711C18.5196 6.89464 18.2653 7 18.0001 7H6.00006C5.73484 7 5.48049 6.89464 5.29295 6.70711C5.10542 6.51957 5.00006 6.26522 5.00006 6C5.00006 5.73478 5.10542 5.48043 5.29295 5.29289C5.48049 5.10536 5.73484 5 6.00006 5ZM18.0001 18C18.0001 18.2652 17.8947 18.5196 17.7072 18.7071C17.5196 18.8946 17.2653 19 17.0001 19H7.00006C6.73484 19 6.48049 18.8946 6.29295 18.7071C6.10542 18.5196 6.00006 18.2652 6.00006 18V9H18.0001V18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.13 12H9.87C9.38951 12 9 12.3895 9 12.87V13.13C9 13.6105 9.38951 14 9.87 14H14.13C14.6105 14 15 13.6105 15 13.13V12.87C15 12.3895 14.6105 12 14.13 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.398784da785e7adbe5bda919b149808c.svg";
export { ForwardRef as ReactComponent };